import React, { useEffect } from 'react';
import { flowRight, get, isEmpty } from 'lodash';
import { connect } from 'react-redux';
import { getJson } from 'session';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import SideScrollingTab from 'modules/common/components/SideScrollingTab';
import TransactionInformation from '../components/TransactionInformation';
import Information from '../components/Information';
import * as actions from '../actions';
import * as c from '../constant';
import { getInitials } from '../helper';

function Content({ match, getItem, item, isLoading, list }) {
  useEffect(() => {
    if (match.params.misc_fee_id && !isEmpty(list)) {
      getItem(match.params.misc_fee_id);
    }
  }, [match.params.misc_fee_id, list]);

  return (
    <div className="card-section-content container-fluid">
      {isLoading && (
        <div className="loading">
          <div className="spinner text-center">
            <span className="fas fa-1x fa-spin fa-spinner" />
          </div>
        </div>
      )}
      <div className="p-3">
        <div className="d-flex mb-3 align-items-center">
          <div className="mr-2 d-flex round-image justify-content-center">
            {get(item, 'included.taxPayer.attributes.photo') && (
              <img
                className="round-image"
                src={get(item, 'included.taxPayer.attributes.photo')}
                alt="Profile"
              />
            )}
            {!get(item, 'included.taxPayer.attributes.photo') && (
              <h3 className="d-flex align-items-center initials mb-0">
                {getInitials(get(item, 'attributes.name_format'))}
              </h3>
            )}
          </div>
          <h1>{get(item, 'attributes.name_format')}</h1>
        </div>
      </div>
      <div className="p-3">
        <Tabs>
          <SideScrollingTab dragToScroll>
            <TabList>
              <Tab>Transaction</Tab>
              <Tab>Information</Tab>
            </TabList>
          </SideScrollingTab>
          <TabPanel>
            <TransactionInformation data={item} />
          </TabPanel>
          <TabPanel>
            <Information data={item} />
          </TabPanel>
        </Tabs>
      </div>
    </div>
  );
}

const mapStateToProps = ({ api }) => {
  return {
    adminProfile: getJson('profile'),
    item: get(api, `${c.ITEM}.item`) || {},
    isLoading: api.loading.indexOf(c.ITEM) > -1,
  };
};

const enhance = flowRight([withRouter, connect(mapStateToProps, actions)]);

Content.propTypes = {
  item: PropTypes.instanceOf(Object).isRequired,
  getItem: PropTypes.instanceOf(Function).isRequired,
  match: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  list: PropTypes.instanceOf(Array).isRequired,
};

export default enhance(Content);
